import React from 'react';
import { Button } from '@mui/material';

import AuthService from '../../services/authService';
import Error from '../../pages/Error';

const UnauthorizedError = (): React.JSX.Element => {
    const unknownErrorMessages = ['Forbidden', 'Not Allowed'];
    const reason = 'It seems like you do not have permissions to view this page. Contact your administrator for access.';

    return (
        <Error messages={unknownErrorMessages} defaultReason={reason} hideBackBtn>
            <Button
                variant='contained'
                color='primary'
                onClick={(): void => {
                    AuthService.logout();
                }}
                data-qa='error-action-logout'
            >
                Log Out
            </Button>
        </Error>
    );
};

export default UnauthorizedError;
